import isVerifyTokenGuard from "@/guards/verifyTokenGuard";
import verifyTokenGuardWithoutPermission from "@/guards/verifyTokenGuardWithoutPermission";

export default {
    name: 'incapacities',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-incapacities-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.incapacities-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "incapacities-create" */ '@/modules/patient-profile/incapacities/views/Create.vue')
        }
    ]
}